module.exports = __WEBPACK_EXTERNAL_MODULE_5__;


//////////////////
// WEBPACK FOOTER
// external "mobx"
// module id = 5
// module chunks = 0 1